import { render, staticRenderFns } from "./SignatureInput.vue?vue&type=template&id=022a50c4&"
import script from "./SignatureInput.vue?vue&type=script&lang=js&"
export * from "./SignatureInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports